import { FilterPeriod } from 'src/constants/filterPeriods/enums/filterPeriod.enum'
import { useQueryParams } from 'src/hooks/useQueryParams'
import { GlobalQueryParams } from 'src/interfaces/globalQueryParams.interface'
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum'
import { createLink } from 'src/utils/createLink'

export const useCustomLink = (link: string): string => {
  const { queryParams } = useQueryParams<GlobalQueryParams>()

  const savedPeriod = localStorage.getItem(
    LocalStorageKey.DATE_FILTER_PERIOD
  ) as FilterPeriod | null

  return createLink(link, {
    queryParams: {
      from: queryParams.from,
      period: queryParams.period || savedPeriod || FilterPeriod.LAST_7_DAYS,
      to: queryParams.to,
    },
  })
}
